import React from "react";
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";

export const FieldSkeleton = (props) => (
    <React.Fragment>
        <Skeleton style={{borderRadius:4}}  variant="rect" height={props.small ? 40 : 55} />
    </React.Fragment>
)